import { getColor } from '../utils';

import { SvgIcon, SvgIconProps } from '../SvgIcon';

export const PhoneCall = ({
  height = 16,
  width = 16,
  color = 'currentColor',
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon width={width} height={height} viewBox="0 0 16 16" {...props}>
    <path
      d="M10.0265 14.9267L10.0345 14.9314C10.7426 15.3822 11.5832 15.578 12.4176 15.4865C13.252 15.395 14.0303 15.0216 14.6238 14.4281L15.1398 13.9121C15.3703 13.6813 15.4997 13.3685 15.4997 13.0424C15.4997 12.7163 15.3703 12.4035 15.1398 12.1727L12.9658 10.0001C12.7351 9.76962 12.4223 9.64017 12.0961 9.64017C11.77 9.64017 11.4572 9.76962 11.2265 10.0001V10.0001C11.1124 10.1143 10.9769 10.205 10.8277 10.2668C10.6785 10.3286 10.5186 10.3605 10.3571 10.3605C10.1957 10.3605 10.0358 10.3286 9.8866 10.2668C9.73744 10.205 9.60192 10.1143 9.48781 10.0001L6.00914 6.52074C5.77868 6.28999 5.64924 5.9772 5.64924 5.65108C5.64924 5.32495 5.77868 5.01216 6.00914 4.78141V4.78141C6.1234 4.6673 6.21403 4.53178 6.27588 4.38262C6.33772 4.23345 6.36955 4.07356 6.36955 3.91208C6.36955 3.7506 6.33772 3.5907 6.27588 3.44154C6.21403 3.29237 6.1234 3.15686 6.00914 3.04274L3.83581 0.866744C3.60506 0.636283 3.29227 0.506836 2.96614 0.506836C2.64002 0.506836 2.32723 0.636283 2.09648 0.866744L1.58048 1.38274C0.987029 1.97633 0.613686 2.75451 0.522058 3.58885C0.43043 4.42319 0.625994 5.26385 1.07648 5.97208L1.08181 5.98008C3.46409 9.50663 6.50046 12.5437 10.0265 14.9267V14.9267Z"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.125"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);
